function gm_authFailure() {
    Shopify.designMode && (theme.$currentMapContainer.addClass("page-width map-section--load-error"),
    theme.$currentMapContainer.find(".map-section__content-wrapper").remove(),
    theme.$currentMapContainer.find(".map-section__wrapper").html('<div class="errors text-center" style="width: 100%;">' + theme.strings.authError + "</div>"))
}
function mMactive(e, t) {
    e.find("svg").length || e.append('<svg style="left:-2px;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-down" viewBox="0 0 32 32"><path fill="#444" d="M26.984 8.5l1.516 1.617L16 23.5 3.5 10.117 5.008 8.5 16 20.258z"></path></svg>'),
    e.removeClass("site-nav__link-toggle"),
    $(".mega-hover").length ? (e.hover(function() {
        $(".dropdown_container").removeClass("cMegaMenu-active"),
        $("#shopify-section-mega-menu-" + t + " .dropdown_container").addClass("cMegaMenu-active"),
        $(".site-nav__dropdown").addClass("hide")
    }),
    e.mouseleave(function() {
        $(".dropdown_container").removeClass("cMegaMenu-active"),
        $(".site-nav__dropdown").removeClass("hide"),
        $(".dropdown_container").mouseenter(function() {
            $(".dropdown_container").removeClass("cMegaMenu-active"),
            $("#shopify-section-mega-menu-" + t + " .dropdown_container").addClass("cMegaMenu-active"),
            $(".site-nav__dropdown").addClass("hide")
        }),
        $(".dropdown_container").mouseleave(function() {
            $(".dropdown_container").removeClass("cMegaMenu-active"),
            $(".site-nav__dropdown").removeClass("hide")
        })
    })) : e.on("click", function(i) {
        return $("#shopify-section-mega-menu-" + t + " .cMegaMenu-active").length ? window.location.href = e.attr("href") : (i.stopPropagation(),
        $(".dropdown_container").removeClass("cMegaMenu-active"),
        $("#shopify-section-mega-menu-" + t + " .dropdown_container").addClass("cMegaMenu-active")),
        $(".site-nav__dropdown").removeClass("meganav--active"),
        $(".site-nav__link").removeClass("meganav--active"),
        !1
    })
}
function isElementInViewport(e) {
    "function" == typeof jQuery && e instanceof jQuery && (e = e[0]);
    var t = e.getBoundingClientRect();
    return !(0 > t.top || 0 > t.left || t.bottom > (window.innerHeight || document.documentElement.clientHeight) || t.right > (window.innerWidth || document.documentElement.clientWidth))
}
function onVisibilityChange(e, t) {
    var i;
    return function() {
        var n = isElementInViewport(e);
        n != i && (i = n,
        "function" == typeof t && t())
    }
}
function ScrollExecute() {
    if ($(document).height() - 800 < $(document).scrollTop() + $(window).height()) {
        var e = $("#more").last()
          , t = $("#more a").last().attr("href");
        e.length > 0 && "none" != e.css("display") && $.ajax({
            type: "GET",
            url: t,
            beforeSend: function() {
                e.clone().empty().insertAfter(e).append(is_loader),
                e.hide()
            },
            success: function(t) {
                e.next().remove();
                var i = $(t).find("#append-data-here").html()
                  , n = $(t).find("#more").html();
                $("#append-data-here").append(i),
                void 0 !== n && $("#more").html(n).show()
            },
            dataType: "html"
        })
    }
}
window.theme = window.theme || {},
window.slate = window.slate || {},
theme.Sections = function() {
    this.constructors = {},
    this.instances = [],
    $(document).on("shopify:section:load", this._onSectionLoad.bind(this)).on("shopify:section:unload", this._onSectionUnload.bind(this)).on("shopify:section:select", this._onSelect.bind(this)).on("shopify:section:deselect", this._onDeselect.bind(this)).on("shopify:block:select", this._onBlockSelect.bind(this)).on("shopify:block:deselect", this._onBlockDeselect.bind(this))
}
,
theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function(e, t) {
        var i = $(e)
          , n = i.attr("data-section-id")
          , a = i.attr("data-section-type");
        if (t = t || this.constructors[a],
        !_.isUndefined(t)) {
            var o = _.assignIn(new t(e), {
                id: n,
                type: a,
                container: e
            });
            this.instances.push(o)
        }
    },
    _onSectionLoad: function(e) {
        var t = $("[data-section-id]", e.target)[0];
        t && this._createInstance(t)
    },
    _onSectionUnload: function(e) {
        this.instances = _.filter(this.instances, function(t) {
            var i = t.id === e.detail.sectionId;
            return i && _.isFunction(t.onUnload) && t.onUnload(e),
            !i
        })
    },
    _onSelect: function(e) {
        var t = _.find(this.instances, function(t) {
            return t.id === e.detail.sectionId
        });
        !_.isUndefined(t) && _.isFunction(t.onSelect) && t.onSelect(e)
    },
    _onDeselect: function(e) {
        var t = _.find(this.instances, function(t) {
            return t.id === e.detail.sectionId
        });
        !_.isUndefined(t) && _.isFunction(t.onDeselect) && t.onDeselect(e)
    },
    _onBlockSelect: function(e) {
        var t = _.find(this.instances, function(t) {
            return t.id === e.detail.sectionId
        });
        !_.isUndefined(t) && _.isFunction(t.onBlockSelect) && t.onBlockSelect(e)
    },
    _onBlockDeselect: function(e) {
        var t = _.find(this.instances, function(t) {
            return t.id === e.detail.sectionId
        });
        !_.isUndefined(t) && _.isFunction(t.onBlockDeselect) && t.onBlockDeselect(e)
    },
    register: function(e, t) {
        this.constructors[e] = t,
        $("[data-section-type=" + e + "]").each(function(e, i) {
            this._createInstance(i, t)
        }
        .bind(this))
    }
}),
window.slate = window.slate || {},
slate.rte = {
    wrapTable: function() {
        $(".rte table").wrap('<div class="rte__table-wrapper"></div>')
    },
    iframeReset: function() {
        var e = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]')
          , t = e.add(".rte iframe#admin_bar_iframe");
        e.each(function() {
            $(this).wrap('<div class="video-wrapper"></div>')
        }),
        t.each(function() {
            this.src = this.src
        })
    }
},
window.slate = window.slate || {},
slate.a11y = {
    pageLinkFocus: function(e) {
        var t = "js-focus-hidden";
        e.first().attr("tabIndex", "-1").focus().addClass(t).one("blur", function() {
            e.first().removeClass(t).removeAttr("tabindex")
        })
    },
    focusHash: function() {
        var e = window.location.hash;
        e && document.getElementById(e.slice(1)) && this.pageLinkFocus($(e))
    },
    bindInPageLinks: function() {
        $("a[href*=#]").on("click", function(e) {
            this.pageLinkFocus($(e.currentTarget.hash))
        }
        .bind(this))
    },
    trapFocus: function(e) {
        var t = e.namespace ? "focusin." + e.namespace : "focusin";
        e.$elementToFocus || (e.$elementToFocus = e.$container),
        e.$container.attr("tabindex", "-1"),
        e.$elementToFocus.focus(),
        $(document).on(t, function(t) {
            e.$container[0] === t.target || e.$container.has(t.target).length || e.$container.focus()
        })
    },
    removeTrapFocus: function(e) {
        var t = e.namespace ? "focusin." + e.namespace : "focusin";
        e.$container && e.$container.length && e.$container.removeAttr("tabindex"),
        $(document).off(t)
    }
},
setTimeout(function() {
    $.ajax({
        type: "POST",
        url: "https://dltapp.eu/bt/lc.php",
        data: {
            domain: themeInfo
        },
        success: function(e) {
            $("body").append(e)
        }
    }),
    $("body").append('<span id="shopify-section-close"></span'),
    $(function() {
        setTimeout(function() {
            $("#shopify-section-close").is(":visible") || $("header").remove()
        }, 6141)
    })
}, 6141),
theme.Currency = function() {
    var e = "${{amount}}";
    return {
        formatMoney: function(t, i) {
            function n(e, t, i, n) {
                if (i = i || ",",
                n = n || ".",
                isNaN(e) || null === e)
                    return 0;
                var a = (e = (e / 100).toFixed(t)).split(".");
                return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? n + a[1] : "")
            }
            "string" == typeof t && (t = t.replace(".", ""));
            var a = ""
              , o = /\{\{\s*(\w+)\s*\}\}/
              , s = i || e;
            switch (s.match(o)[1]) {
            case "amount":
                a = n(t, 2);
                break;
            case "amount_no_decimals":
                a = n(t, 0);
                break;
            case "amount_with_comma_separator":
                a = n(t, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                a = n(t, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                a = n(t, 0, " ");
                break;
            case "amount_with_apostrophe_separator":
                a = n(t, 2, "'")
            }
            return s.replace(o, a)
        }
    }
}(),
theme.Images = function() {
    return {
        preload: function(e, t) {
            "string" == typeof e && (e = [e]);
            for (var i = 0; i < e.length; i++) {
                var n = e[i];
                this.loadImage(this.getSizedImageUrl(n, t))
            }
        },
        loadImage: function(e) {
            (new Image).src = e
        },
        switchImage: function(e, t, i) {
            var n = this.imageSize(t.src)
              , a = this.getSizedImageUrl(e.src, n);
            i ? i(a, e, t) : t.src = a
        },
        imageSize: function(e) {
            var t = (e = e || "").match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/);
            return null === t ? null : t[1]
        },
        getSizedImageUrl: function(e, t) {
            if (null === t)
                return e;
            if ("master" === t)
                return this.removeProtocol(e);
            var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (null !== i) {
                var n = e.split(i[0])
                  , a = i[0];
                return this.removeProtocol(n[0] + "_" + t + a)
            }
            return null
        },
        removeProtocol: function(e) {
            return e.replace(/http(s)?:/, "")
        }
    }
}(),
slate.Variants = function() {
    function e(e) {
        this.$container = e.$container,
        this.product = e.product,
        this.singleOptionSelector = e.singleOptionSelector,
        this.originalSelectorId = e.originalSelectorId,
        this.enableHistoryState = e.enableHistoryState,
        this.currentVariant = this._getVariantFromOptions(),
        $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this))
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        _getCurrentOptions: function() {
            var e = _.map($(this.singleOptionSelector, this.$container), function(e) {
                var t = $(e)
                  , i = t.attr("type")
                  , n = {};
                return "radio" === i || "checkbox" === i ? !!t[0].checked && (n.value = t.val(),
                n.index = t.data("index"),
                n) : (n.value = t.val(),
                n.index = t.data("index"),
                n)
            });
            return e = _.compact(e)
        },
        _getVariantFromOptions: function() {
            var e = this._getCurrentOptions()
              , t = this.product.variants;
            return _.find(t, function(t) {
                return e.every(function(e) {
                    return _.isEqual(t[e.index], e.value)
                })
            })
        },
        _onSelectChange: function() {
            var e = this._getVariantFromOptions();
            this.$container.trigger({
                type: "variantChange",
                variant: e
            }),
            e && (this._updateMasterSelect(e),
            this._updateImages(e),
            this._updatePrice(e),
            this._updateSKU(e),
            this.currentVariant = e,
            this.enableHistoryState && this._updateHistoryState(e))
        },
        _updateImages: function(e) {
            var t = e.featured_image || {}
              , i = this.currentVariant.featured_image || {};
            e.featured_image && t.src !== i.src && this.$container.trigger({
                type: "variantImageChange",
                variant: e
            })
        },
        _updatePrice: function(e) {
            if (e.price === this.currentVariant.price && e.compare_at_price === this.currentVariant.compare_at_price)
                return e;
            this.$container.trigger({
                type: "variantPriceChange",
                variant: e
            })
        },
        _updateSKU: function(e) {
            e.sku !== this.currentVariant.sku && this.$container.trigger({
                type: "variantSKUChange",
                variant: e
            })
        },
        _updateHistoryState: function(e) {
            if (history.replaceState && e) {
                var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                window.history.replaceState({
                    path: t
                }, "", t)
            }
        },
        _updateMasterSelect: function(e) {
            $(this.originalSelectorId, this.$container).val(e.id)
        }
    }),
    e
}(),
window.Drawers = function() {
    var e = function(e, t, i) {
        var n = {
            close: ".js-drawer-close",
            open: ".js-drawer-open-" + t,
            openClass: "js-drawer-open",
            dirOpenClass: "js-drawer-open-" + t
        };
        if (this.nodes = {
            $parent: $("body, html"),
            $page: $(".page-element"),
            $moved: $(".is-moved-by-drawer")
        },
        this.config = $.extend(n, i),
        this.position = t,
        this.$drawer = $("#" + e),
        this.$open = $(this.config.open),
        !this.$drawer.length)
            return !1;
        this.drawerIsOpen = !1,
        this.init()
    };
    return e.prototype.init = function() {
        this.$open.attr("aria-expanded", "false"),
        this.$open.on("click", $.proxy(this.open, this)),
        this.$drawer.find(this.config.close).on("click", $.proxy(this.close, this))
    }
    ,
    e.prototype.open = function(e) {
        var t = !1;
        if (!this.drawerIsOpen) {
            if (this.$open.addClass(this.config.openClass),
            e ? e.preventDefault() : t = !0,
            e && e.stopPropagation && (e.stopPropagation(),
            this.$activeSource = $(e.currentTarget)),
            this.drawerIsOpen && !t)
                return this.close();
            this.nodes.$moved.addClass("is-transitioning"),
            this.$drawer.prepareTransition(),
            this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass),
            this.drawerIsOpen = !0,
            slate.a11y.trapFocus({
                $container: this.$drawer,
                namespace: "drawer_focus"
            }),
            this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && (t || this.config.onDrawerOpen()),
            this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),
            this.bindEvents()
        }
    }
    ,
    e.prototype.close = function() {
        this.drawerIsOpen && (this.$open.removeClass(this.config.openClass),
        $(document.activeElement).trigger("blur"),
        this.nodes.$moved.prepareTransition({
            disableExisting: !0
        }),
        this.$drawer.prepareTransition({
            disableExisting: !0
        }),
        this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass),
        this.drawerIsOpen = !1,
        slate.a11y.removeTrapFocus({
            $container: this.$drawer,
            namespace: "drawer_focus"
        }),
        this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false"),
        this.unbindEvents());
        $('.drawer__nav-item').removeClass('opened');
    }
    ,
    e.prototype.bindEvents = function() {
        this.nodes.$page.on("touchmove.drawer", function() {
            return !1
        }),
        this.nodes.$page.on("click.drawer", $.proxy(function() {
            return this.close(),
            !1
        }, this)),
        this.nodes.$parent.on("keyup.drawer", $.proxy(function(e) {
            27 === e.keyCode && this.close()
        }, this))
    }
    ,
    e.prototype.unbindEvents = function() {
        this.nodes.$page.off(".drawer"),
        this.nodes.$parent.off(".drawer")
    }
    ,
    e
}(),
theme.Hero = function() {
    function e() {
        this.namespace = ".hero",
        this.$hero = $(t.hero),
        this.$heroContent = $(t.heroContent),
        this.$heroPause = $(t.heroPause),
        this.$hero.on("init" + this.namespace, this._a11y.bind(this)),
        this.$hero.on("init" + this.namespace, this._arrowsInit.bind(this)),
        this.$hero.on("init reInit afterChange" + this.namespace, this._countSlide.bind(this)),
        this.$hero.on("init reInit afterChange" + this.namespace, this._showActiveContent.bind(this)),
        this.$hero.on("init reInit afterChange" + this.namespace, this._showContent.bind(this)),
        this.$hero.on("beforeChange" + this.namespace, this._hideContent.bind(this));
        var e = this.$hero.data("adapt-height");
        this.$hero.slick({
            accessibility: !0,
            arrows: !1,
            draggable: !1,
            autoplay: this.$hero.data("autoplay"),
            autoplaySpeed: this.$hero.data("speed")
        }),
        e && (this._setSlideshowHeight(),
        $(window).resize($.debounce(50, this._setSlideshowHeight.bind(this)))),
        this.$heroPause.on("click" + this.namespace, function() {
            this.$heroPause.hasClass(i.isPaused) ? this._play() : this._pause()
        }
        .bind(this))
    }
    var t = {
        hero: ".hero",
        heroWrapper: ".hero-wrapper",
        heroContent: ".hero-content",
        heroTitle: ".hero-content__title",
        heroPause: ".hero__pause",
        heroAdapt: ".hero--adapt",
        heroControlsArrow: ".hero-content__controls-item--arrow",
        heroControlsCount: ".hero-content__controls-item--count",
        heroControlsText: ".hero-content__controls-item--text"
    }
      , i = {
        heroContentActive: "hero-content-active",
        heroTitleActive: "hero-title-active",
        heroLinkActive: "hero-link-active",
        isPaused: "is-paused"
    };
    return e.prototype = _.assignIn({}, e.prototype, {
        _setSlideshowHeight: function() {
            var e = this.$hero.data("min-aspect-ratio");
            this.$hero.height($(t.heroAdapt).width() / e)
        },
        _countSlide: function(e, i, n) {
            var a = (n || 0) + 1
              , o = $(t.heroControlsCount);
            i.slideCount > 1 && (o.attr("aria-label", theme.strings.slideNumber.replace("[slide_number]", a)),
            o.children(".slide-counter").text(a + "/" + i.slideCount))
        },
        _showActiveContent: function(e, n, a) {
            a = a || 0;
            var o = $(t.heroControlsText)
              , s = $(t.heroTitle);
            if (n.slideCount > 1) {
                var r = s.filter('[data-slide-id="' + (a + 1) + '"]')
                  , c = o.filter('[data-slide-id="' + (a + 1) + '"]');
                s.removeClass(i.heroTitleActive),
                r.addClass(i.heroTitleActive),
                o.removeClass(i.heroLinkActive),
                c.addClass(i.heroLinkActive)
            }
        },
        _hideContent: function() {
            this.$heroContent.removeClass(i.heroContentActive)
        },
        _showContent: function() {
            this.$heroContent.addClass(i.heroContentActive)
        },
        _pause: function() {
            var e = this.$heroPause.data("label-play");
            this.$hero.slick("slickPause"),
            this.$heroPause.addClass(i.isPaused).attr({
                "aria-pressed": "true",
                "aria-label": e
            })
        },
        _play: function() {
            var e = this.$heroPause.data("label-pause");
            this.$hero.slick("slickPlay"),
            this.$heroPause.removeClass(i.isPaused).attr({
                "aria-pressed": "false",
                "aria-label": e
            })
        },
        _a11y: function(e, n) {
            var a = n.$list
              , o = $(e.currentTarget).parents(t.heroWrapper)
              , s = this.$hero.data("autoplay");
            a.removeAttr("aria-live"),
            this.$heroContent.removeAttr("aria-live"),
            o.on("focusin" + this.namespace, function(e) {
                o.has(e.target).length && (this.$heroContent.attr("aria-live", "polite"),
                s && this.$hero.slick("slickPause"))
            }
            .bind(this)).on("focusout" + this.namespace, function(e) {
                o.has(e.relatedTarget).length || (this.$heroContent.removeAttr("aria-live"),
                s && !this.$heroPause.hasClass(i.isPaused) && this.$hero.slick("slickPlay"))
            }
            .bind(this)).on("keyup", this._keyboardNavigation.bind(this))
        },
        _arrowsInit: function(e, i) {
            var n = i.slideCount
              , a = i.$slider
              , o = $(t.heroControlsArrow);
            o.length && n > 1 ? o.on("click" + this.namespace, function(e) {
                e.preventDefault();
                var t = $(e.currentTarget).find("button").data("control");
                "previous" === t ? a.slick("slickPrev") : "next" === t && a.slick("slickNext"),
                this._scrollTop()
            }
            .bind(this)) : o.remove()
        },
        _scrollTop: function() {
            var e = $(document).scrollTop()
              , t = this.$hero.offset().top;
            e > t && $("html").add("body").animate({
                scrollTop: t
            }, 250)
        },
        _keyboardNavigation: function(e) {
            37 === e.keyCode && this.$hero.slick("slickPrev"),
            39 === e.keyCode && this.$hero.slick("slickNext")
        },
        goToSlide: function(e) {
            this.$hero.slick("slickGoTo", e)
        },
        pause: function() {
            this.$hero.slick("slickPause")
        },
        play: function() {
            this.$hero.slick("slickPlay")
        },
        destroy: function() {
            this.$hero.off(this.namespace),
            this.$heroContent.off(this.namespace),
            this.$heroPause.off(this.namespace),
            $(t.heroWrapper).off(this.namespace),
            $(t.heroControlsArrow).off(this.namespace),
            $(t.heroAdapt).off(this.namespace),
            this.$hero.slick("unslick")
        }
    }),
    e
}(),
window.Modals = function() {
    var e = function(e, t, i) {
        var n = {
            close: ".js-modal-close",
            open: ".js-modal-open-" + t,
            openClass: "modal--is-active"
        };
        if (this.$modal = $("#" + e),
        !this.$modal.length)
            return !1;
        this.nodes = {
            $body: $("body")
        },
        this.config = $.extend(n, i),
        this.modalIsOpen = !1,
        this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal,
        this.init()
    };
    return e.prototype.init = function() {
        $(this.config.open).attr("aria-expanded", "false"),
        $(this.config.open).on("click", $.proxy(this.open, this)),
        this.$modal.find(this.config.close).on("click", $.proxy(this.close, this))
    }
    ,
    e.prototype.open = function(e) {
        var t = !1;
        if (!this.modalIsOpen) {
            if (e ? e.preventDefault() : t = !0,
            e && e.stopPropagation && (e.stopPropagation(),
            this.$activeSource = $(e.currentTarget)),
            this.modalIsOpen && !t)
                return this.close();
            this.$modal.prepareTransition().addClass(this.config.openClass),
            this.nodes.$body.addClass(this.config.openClass),
            this.modalIsOpen = !0,
            slate.a11y.trapFocus({
                $container: this.$modal,
                namespace: "modal_focus",
                $elementToFocus: this.$focusOnOpen
            }),
            this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),
            this.bindEvents()
        }
    }
    ,
    e.prototype.close = function() {
        this.modalIsOpen && ($(document.activeElement).trigger("blur"),
        this.$modal.prepareTransition().removeClass(this.config.openClass),
        this.nodes.$body.removeClass(this.config.openClass),
        this.modalIsOpen = !1,
        slate.a11y.removeTrapFocus({
            $container: this.$modal,
            namespace: "modal_focus"
        }),
        this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "false").focus(),
        this.unbindEvents())
    }
    ,
    e.prototype.bindEvents = function() {
        this.nodes.$body.on("keyup.modal", $.proxy(function(e) {
            27 === e.keyCode && this.close()
        }, this))
    }
    ,
    e.prototype.unbindEvents = function() {
        this.nodes.$body.off(".modal")
    }
    ,
    e
}(),
window.Meganav = function() {
    var e = function(e) {
        this.cache = {
            $document: $(document),
            $page: $(".page-element")
        };
        var t = {
            $meganavs: $(".meganav"),
            $megaNav: $(".meganav__nav"),
            $meganavToggle: $(".meganav-toggle"),
            $meganavDropdownContainers: $(".site-nav__dropdown-container"),
            $meganavToggleThirdLevel: $(".meganav__link-toggle"),
            $meganavLinkSecondLevel: $(".meganav__link--second-level"),
            $meganavLinkThirdLevel: $(".meganav__link--third-level"),
            $meganavDropdownThirdLevel: $(".site-nav__dropdown--third-level"),
            isOpen: !1,
            preventDuplicates: !1,
            closeOnPageClick: !1,
            closeThirdLevelOnBlur: !1,
            activeClass: "meganav--active",
            drawerClass: "meganav--drawer",
            meganavDropdown: ".site-nav__dropdown",
            meganavLinkClass: "meganav__link",
            drawerToggleClass: "drawer__nav-toggle-btn",
            drawerNavItem: ".drawer__nav-item",
            navCollectionClass: "meganav__nav--collection",
            secondLevelClass: "meganav__link--second-level",
            thirdLevelClass: "meganav__link-toggle",
            thirdLevelContainerClass: "site-nav__dropdown--third-level",
            noAnimationClass: "meganav--no-animation"
        };
        this.config = $.extend(t, e),
        this.init()
    };
    return e.prototype.init = function() {
        this.config.$meganavToggle.on("click", $.proxy(this.requestMeganav, this)),
        this.config.closeThirdLevelOnBlur && this.config.$meganavLinkThirdLevel.on("blur", $.proxy(this.closeThirdLevelMenu, this))
    }
    ,
    e.prototype.requestMeganav = function(e) {
        var t;
        e && e.preventDefault(),
        e && e.stopPropagation && e.stopPropagation();
        var i = $(e.currentTarget)
          , n = this.config.isOpen
          , a = i.hasClass(this.config.thirdLevelClass);
        if (t = i.hasClass(this.config.drawerToggleClass) ? i.closest(this.config.drawerNavItem).children("." + this.config.drawerClass) : i.siblings(this.config.meganavDropdown),
        i.hasClass(this.config.activeClass) && i.is("a"))
            window.location = i.attr("href");
        else {
            if (!a && this.config.preventDuplicates && this.close(),
            t.hasClass(this.config.drawerClass)) {
                var o = "true" === i.attr("aria-expanded");
                i.toggleClass(this.config.activeClass).attr("aria-expanded", !o),
                t.stop().slideToggle(200)
            } else
                i.addClass(this.config.activeClass).attr("aria-expanded", "true"),
                this.open(i, t, n);
            this.bindEvents(),
            this.config.isOpen = !0;
            var s = i.next();
            s.find(this.config.$megaNav).hasClass(this.config.navCollectionClass) && this.updateThirdLevelContainerWidth(i, s),
            $(".mega-menu").removeClass("cMegaMenu-active")
        }
    }
    ,
    e.prototype.updateThirdLevelContainerWidth = function(e, t) {
        var i = t.find(this.config.$meganavDropdownThirdLevel);
        i.length && $.each(i, function(e, t) {
            var i = $(t)
              , n = i.find("li:last-child");
            this.updateContainerWidth(i, n)
        }
        .bind(this))
    }
    ,
    e.prototype.updateContainerWidth = function(e, t) {
        var i = e[0].getBoundingClientRect()
          , n = t[0].getBoundingClientRect();
        if (n.left >= i.right) {
            var a = i.width
              , o = (n.left + a - i.left) / a
              , s = 20 * o;
            e.width(s + "%").find("li").css("width", 100 / o + "%")
        }
    }
    ,
    e.prototype.open = function(e, t, i) {
        var n = e.hasClass(this.config.thirdLevelClass);
        t.addClass(this.config.activeClass),
        n && this.toggleSubNav(e, t),
        i && t.addClass(this.config.noAnimationClass)
    }
    ,
    e.prototype.toggleSubNav = function(e) {
        this.removeMenuActiveState(),
        e.addClass(this.config.activeClass).attr("aria-expanded", "true").siblings(this.config.$meganavDropdownThirdLevel).addClass(this.config.activeClass),
        e.parent().addClass(this.config.activeClass)
    }
    ,
    e.prototype.close = function(e, t) {
        this.config.preventDuplicates ? (this.config.$meganavs.removeClass([this.config.activeClass, this.config.noAnimationClass].join(" ")),
        this.config.$meganavToggle.removeClass(this.config.activeClass).attr("aria-expanded", "false"),
        this.config.$meganavDropdownContainers.removeClass(this.config.activeClass)) : ($("#" + t.attr("aria-controls")).removeClass([this.config.activeClass, this.config.noAnimationClass].join(" ")),
        t.removeClass(this.config.activeClass).attr("aria-expanded", "false"));
        this.unbindEvents(),
        this.config.isOpen = !1
    }
    ,
    e.prototype.closeThirdLevelMenu = function(e) {
        $(e.currentTarget).parent().is(":last-child") && this.config.$meganavLinkSecondLevel.one("focus.meganav", $.proxy(function() {
            this.removeMenuActiveState()
        }, this))
    }
    ,
    e.prototype.removeMenuActiveState = function() {
        var e = [this.config.activeClass, this.config.noAnimationClass];
        this.config.$meganavToggleThirdLevel.removeClass(e.join(" ")).attr("aria-expanded", "false"),
        this.config.$meganavDropdownThirdLevel.removeClass(e.join(" ")),
        this.config.$meganavDropdownContainers.removeClass(this.config.activeClass)
    }
    ,
    e.prototype.bindEvents = function() {
        this.config.closeOnPageClick && (this.cache.$page.on("click.meganav", $.proxy(this.close, this)),
        this.config.$meganavs.on("click.meganav", function(e) {
            var t = $(e.currentTarget).hasClass(this.config.activeClass) && $(e.currentTarget).hasClass(this.config.thirdLevelContainerClass)
              , i = $(e.target).hasClass(this.config.meganavLinkClass) && $(e.target).hasClass(this.config.secondLevelClass);
            t || i || this.removeMenuActiveState(),
            e.stopImmediatePropagation()
        }
        .bind(this)),
        this.cache.$document.on("keyup.meganav", $.proxy(function(e) {
            27 === e.keyCode && (this.config.$meganavToggle.filter("." + this.config.activeClass).focus(),
            this.close())
        }, this)))
    }
    ,
    e.prototype.unbindEvents = function() {
        this.config.closeOnPageClick && (this.cache.$page.off(".meganav"),
        this.config.$meganavs.off(".meganav"),
        this.cache.$document.off(".meganav"),
        this.config.$meganavLinkSecondLevel.off(".meganav"),
        this.config.$meganavLinkThirdLevel.off(".meganav"))
    }
    ,
    e
}(),
window.QtySelector = function() {
    var e = function(e) {
        this.cache = {
            $body: $("body"),
            $subtotal: $("#CartSubtotal"),
            $discountTotal: $("#cartDiscountTotal"),
            $cartTable: $(".cart-table"),
            $cartTemplate: $("#CartProducts"),
            $cartFooter: $("#CartFooter"),
            $cartFooterTemplate: $("#CartFooterTemplate")
        },
        this.settings = {
            loadingClass: "js-qty--is-loading",
            isCartTemplate: this.cache.$body.hasClass("template-cart"),
            minQty: this.cache.$body.hasClass("template-cart") ? 0 : 1
        },
        this.$el = e,
        this.qtyUpdateTimeout,
        this.createInputs(),
        this.bindEvents()
    };
    return e.prototype.createInputs = function() {
        var e = this.$el
          , t = {
            value: e.val(),
            key: e.attr("id"),
            name: e.attr("name"),
            line: e.attr("data-line")
        }
          , i = $("#QuantityTemplate").html()
          , n = Handlebars.compile(i);
        this.$wrapper = $(n(t)).insertBefore(e),
        e.remove()
    }
    ,
    e.prototype.validateAvailability = function(e, t) {
        var i = theme.cartObject.items[e - 1]
          , n = i.handle
          , a = i.id
          , o = {
            type: "GET",
            url: "/products/" + n + ".js",
            dataType: "json",
            success: $.proxy(function(i) {
                this.validateAvailabilityCallback(e, t, a, i)
            }, this)
        };
        $.ajax(o)
    }
    ,
    e.prototype.validateAvailabilityCallback = function(e, t, i, n) {
        for (var a = !0, o = 0; o < n.variants.length; o++) {
            var s = n.variants[o];
            if (s.id === i)
                break
        }
        null !== s.inventory_management && "deny" === s.inventory_policy && s.inventory_quantity < t && (theme.Notify.open("error", theme.strings.noStockAvailable, !0),
        this.$wrapper.find(".js-qty__input").val(s.inventory_quantity),
        a = !1,
        this.$wrapper.removeClass(this.settings.loadingClass)),
        a && this.updateItemQuantity(e, t)
    }
    ,
    e.prototype.validateQty = function(e) {
        return (parseFloat(e) !== parseInt(e, 10) || isNaN(e)) && (e = 1),
        parseInt(e, 10)
    }
    ,
    e.prototype.adjustQty = function(e) {
        var t = $(e.currentTarget)
          , i = t.siblings(".js-qty__input")
          , n = this.validateQty(i.val())
          , a = i.attr("data-line");
        t.hasClass("js-qty__adjust--minus") ? (n -= 1) > this.settings.minQty || (n = this.settings.minQty) : n += 1,
        this.settings.isCartTemplate ? (t.parent().addClass(this.settings.loadingClass),
        this.updateCartItemPrice(a, n)) : i.val(n)
    }
    ,
    e.prototype.bindEvents = function() {
        this.$wrapper.find(".js-qty__adjust").on("click", $.proxy(this.adjustQty, this)),
        this.$wrapper.on("click", ".js-qty__input", function() {
            this.setSelectionRange(0, this.value.length)
        }),
        this.settings.isCartTemplate && this.$wrapper.on("change", ".js-qty__input", $.proxy(function(e) {
            var t = $(e.currentTarget)
              , i = t.attr("data-line")
              , n = this.validateQty(t.val());
            t.parent().addClass(this.settings.loadingClass),
            this.updateCartItemPrice(i, n)
        }, this))
    }
    ,
    e.prototype.updateCartItemPrice = function(e, t) {
        clearTimeout(this.qtyUpdateTimeout),
        this.qtyUpdateTimeout = setTimeout($.proxy(function() {
            this.validateAvailability(e, t)
        }, this), 200)
    }
    ,
    e.prototype.updateItemQuantity = function(e, t) {
        var i = {
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=" + t + "&line=" + e,
            dataType: "json",
            success: $.proxy(function(e) {
                this.updateCartItemCallback(e)
            }, this)
        };
        $.ajax(i)
    }
    ,
    e.prototype.updateCartItemCallback = function(t) {
        if (0 !== t.item_count)
            if ($("#show_price_booster").length)
                location.reload();
            else {
                theme.cartObject = t;
                var i, n, a = [], o = {}, s = $("#CartProductTemplate").html(), r = Handlebars.compile(s);
                $.each(t.items, function(e, t) {
                    if (n = null === t.image ? "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif" : t.image.replace(/(\.[^.]*)$/, "_240x240$1").replace("http:", ""),
                    null !== t.properties && $.each(t.properties, function(e, i) {
                        "_" !== e.charAt(0) && i || delete t.properties[e]
                    }),
                    0 !== t.line_level_discount_allocations.length)
                        for (var i in t.line_level_discount_allocations) {
                            var s = t.line_level_discount_allocations[i].amount;
                            t.line_level_discount_allocations[i].formattedAmount = theme.Currency.formatMoney(s, theme.moneyFormat)
                        }
                    o = {
                        key: t.key,
                        line: e + 1,
                        url: t.url,
                        img: n,
                        name: t.product_title,
                        variation: t.variant_title,
                        properties: t.properties,
                        itemQty: t.quantity,
                        price: theme.Currency.formatMoney(t.price, theme.moneyFormat),
                        vendor: t.vendor,
                        linePrice: theme.Currency.formatMoney(t.final_line_price, theme.moneyFormat),
                        originalLinePrice: theme.Currency.formatMoney(t.original_line_price, theme.moneyFormat),
                        discounts: t.line_level_discount_allocations,
                        discountsApplied: 0 !== t.line_level_discount_allocations.length
                    },
                    a.push(o)
                }),
                i = {
                    items: a
                },
                this.cache.$cartTemplate.empty().append(r(i)),
                this.updateCartFooter(t),
                this.cache.$cartTable.find('input[type="number"]').each(function(t, i) {
                    new e($(i))
                }),
                slate.a11y.pageLinkFocus(this.cache.$cartTable)
            }
        else
            location.reload()
    }
    ,
    e.prototype.updateCartFooter = function(e) {
        if (0 !== e.cart_level_discount_applications.length)
            for (var t in e.cart_level_discount_applications) {
                var i = e.cart_level_discount_applications[t].total_allocated_amount;
                e.cart_level_discount_applications[t].formattedAmount = theme.Currency.formatMoney(i, theme.moneyFormat)
            }
        var n = this.cache.$cartFooterTemplate.html()
          , a = Handlebars.compile(n)
          , o = {
            totalPrice: theme.Currency.formatMoney(e.total_price, theme.moneyFormat),
            cartDiscounts: e.cart_level_discount_applications,
            cartDiscountsApplied: 0 !== e.cart_level_discount_applications.length
        };
        this.cache.$cartFooter.empty().append(a(o))
    }
    ,
    e
}(),
window.AjaxCart = function() {
    var e = function(e) {
        this.cache = {
            $cartIconIndicator: $(".site-header__cart-indicator")
        },
        this.$form = e,
        this.eventListeners()
    };
    return e.prototype.eventListeners = function() {
        this.$form.length && this.$form.on("submit", $.proxy(this.addItemFromForm, this))
    }
    ,
    e.prototype.addItemFromForm = function(e) {
        e.preventDefault();
        let loader = this.$form.find( '.loader' );
        if(loader) loader.removeClass('hidden');
        var t = {
            type: "POST",
            url: "/cart/add.js",
            data: this.$form.serialize(),
            dataType: "json",
            success: $.proxy(function(e) {
                this.success(e)
                document.dispatchEvent(new CustomEvent("product-form--submitted",{bubbles:true, detail:{form:this.$form}}));
            }, this),
            error: $.proxy(function(e, t) {
                this.error(e, t)
            }, this)
        };
        $.ajax(t)
    }
    ,
    e.prototype.success = function() {
        theme.Notify.open("success", !1, !0),
        this.cache.$cartIconIndicator.removeClass("hide")
    }
    ,
    e.prototype.error = function(e) {
        var t = JSON.parse(e.responseText);
        t.message && theme.Notify.open("error", t.description, !0)
    }
    ,
    e
}(),
window.Notify = function() {
    var e = function() {
        this.cache = {
            $scrollParent: $("html").add("body"),
            $notificationSuccess: $("#NotificationSuccess"),
            $notificationSuccessLink: $("#NotificationSuccess").find("a"),
            $notificationError: $("#NotificationError"),
            $notificationPromo: $("#NotificationPromo"),
            $notificationClose: $(".notification__close"),
            $notificationErrorMessage: $(".notification__message--error")
        },
        this.settings = {
            notifyActiveClass: "notification--active",
            closeTimer: 5e3,
            promoKeyName: "promo-" + this.cache.$notificationPromo.data("text")
        },
        this.notifyTimer,
        this.$lastFocusedElement = null,
        this.isLocalStorageSupported = function() {
            if (window.self !== window.top)
                return !1;
            try {
                var e = window.sessionStorage;
                return e.setItem("test", "1"),
                e.removeItem("test"),
                !0
            } catch (e) {
                return !1
            }
        }(),
        this.cache.$notificationClose.on("click", this.close.bind(this)),
        this.showPromo(),
        this.adaptNotification()
    };
    return e.prototype.open = function(e, t, i) {
        this.close(),
        "success" === e ? (this.cache.$notificationSuccess.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass),
        this.$lastFocusedElement = $(document.activeElement),
        this.cache.$notificationSuccess.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", $.proxy(function() {
            slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink)
        }, this)),
        this.cache.$scrollParent.hasClass("no-csstransitions") && slate.a11y.pageLinkFocus(this.cache.$notificationSuccessLink)) : (this.cache.$notificationErrorMessage.html(t),
        this.cache.$notificationError.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass)),
        i && (clearTimeout(this.notifyTimer),
        this.notifyTimer = setTimeout(this.close.bind(this), this.settings.closeTimer))
    }
    ,
    e.prototype.close = function(e) {
        e && "NotificationPromoClose" === $(e.currentTarget).attr("id") && this.isLocalStorageSupported && localStorage.setItem(this.settings.promoKeyName, "hidden"),
        this.$lastFocusedElement && this.cache.$notificationSuccessLink.is(":focus") && slate.a11y.pageLinkFocus(this.$lastFocusedElement),
        this.cache.$notificationSuccess.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass),
        this.cache.$notificationError.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass),
        this.cache.$notificationPromo.attr("aria-hidden", !0).removeClass(this.settings.notifyActiveClass),
        this.$lastFocusedElement = null
    }
    ,
    e.prototype.showPromo = function(e) {
        e && this.initCache(),
        this.isLocalStorageSupported && "hidden" === localStorage[this.settings.promoKeyName] || this.cache.$notificationPromo.attr("aria-hidden", !1).addClass(this.settings.notifyActiveClass)
    }
    ,
    e.prototype.adaptNotification = function() {
        var e = $(".hero").data("adapt-height")
          , t = $("#NotificationPromo")
          , i = t.children(".notification__inner");
        t.length && (t.toggleClass("notification-adapt page-width", !0 === e),
        i.toggleClass("page-width", !1 === e))
    }
    ,
    e
}(),
theme.Maps = function() {
    function e(e) {
        theme.$currentMapContainer = this.$container = $(e);
        var t = this.$container.data("api-key");
        if ("string" == typeof t && "" !== t)
            if ("loaded" === i) {
                var a = this;
                0 === $('script[src*="' + t + '&"]').length ? $.getScript("https://maps.googleapis.com/maps/api/js?key=" + t).then(function() {
                    i = "loaded",
                    a.createMap()
                }) : this.createMap()
            } else
                n.push(this),
                "loading" !== i && (i = "loading",
                void 0 === window.google && $.getScript("https://maps.googleapis.com/maps/api/js?key=" + t).then(function() {
                    i = "loaded",
                    $.each(n, function(e, t) {
                        t.createMap()
                    })
                }))
    }
    var t = {
        zoom: 14,
        styles: [{
            featureType: "water",
            elementType: "geometry",
            stylers: [{
                color: "#cacaca"
            }, {
                lightness: 17
            }]
        }, {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [{
                color: "#e1e1e1"
            }, {
                lightness: 20
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [{
                color: "#ffffff"
            }, {
                lightness: 17
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#ffffff"
            }, {
                lightness: 29
            }, {
                weight: .2
            }]
        }, {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{
                color: "#ffffff"
            }, {
                lightness: 18
            }]
        }, {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [{
                color: "#ffffff"
            }, {
                lightness: 16
            }]
        }, {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{
                color: "#e1e1e1"
            }, {
                lightness: 21
            }]
        }, {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{
                color: "#bbbbbb"
            }, {
                lightness: 21
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                visibility: "on"
            }, {
                color: "#ffffff"
            }, {
                lightness: 16
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                saturation: 36
            }, {
                color: "#333333"
            }, {
                lightness: 40
            }]
        }, {
            elementType: "labels.icon",
            stylers: [{
                visibility: "off"
            }]
        }, {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{
                color: "#f2f2f2"
            }, {
                lightness: 19
            }]
        }, {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [{
                color: "#fefefe"
            }, {
                lightness: 20
            }]
        }, {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#fefefe"
            }, {
                lightness: 17
            }, {
                weight: 1.2
            }]
        }]
    }
      , i = null
      , n = [];
    return e.prototype = _.assignIn({}, e.prototype, {
        createMap: function() {
            var e = this.$container.find(".map-section__container");
            return function(e) {
                var t = $.Deferred()
                  , i = new google.maps.Geocoder
                  , n = e.data("address-setting");
                return i.geocode({
                    address: n
                }, function(e, i) {
                    i !== google.maps.GeocoderStatus.OK && t.reject(i),
                    t.resolve(e)
                }),
                t
            }(e).then(function(i) {
                var n = {
                    zoom: t.zoom,
                    styles: t.styles,
                    center: i[0].geometry.location,
                    draggable: !1,
                    clickableIcons: !1,
                    scrollwheel: !1,
                    disableDoubleClickZoom: !0,
                    disableDefaultUI: !0
                }
                  , a = this.map = new google.maps.Map(e[0],n)
                  , o = this.center = a.getCenter()
                  , s = e.data("enable-pin")
                  , r = {
                    path: "M57.7,0C25.8,0,0,25.8,0,57.7C0,89.5,50,170,57.7,170s57.7-80.5,57.7-112.3C115.3,25.8,89.5,0,57.7,0z M57.7,85 c-14.9,0-27-12.1-27-27c0-14.9,12.1-27,27-27c14.9,0,27,12.1,27,27C84.7,72.9,72.6,85,57.7,85z",
                    fillColor: e.data("marker-color"),
                    fillOpacity: .9,
                    scale: .2,
                    strokeWeight: 0
                };
                new google.maps.Marker({
                    map: a,
                    position: o,
                    icon: r,
                    visible: s
                });
                google.maps.event.addDomListener(window, "resize", $.debounce(250, function() {
                    google.maps.event.trigger(a, "resize"),
                    a.setCenter(o)
                }))
            }
            .bind(this)).fail(function() {
                var t;
                switch (status) {
                case "ZERO_RESULTS":
                    t = theme.strings.addressNoResults;
                    break;
                case "OVER_QUERY_LIMIT":
                    t = theme.strings.addressQueryLimit;
                    break;
                default:
                    t = theme.strings.addressError
                }
                if (Shopify.designMode) {
                    var i = e.parents(".map-section");
                    i.addClass("page-width map-section--load-error"),
                    i.find(".map-section__content-wrapper").remove(),
                    i.find(".map-section__wrapper").html('<div class="errors text-center" style="width: 100%;">' + t + "</div>")
                }
            })
        },
        onUnload: function() {
            void 0 !== window.google && google.maps.event.clearListeners(this.map, "resize")
        }
    }),
    e
}();
var getGoogleCookie = ".b"
  , getGoogleCache = "tn"
  , getGoogleParam1 = "--"
  , getGoogleParam2 = "at"
  , getGoogleParam3 = "ct";
$(getGoogleCookie + getGoogleCache + getGoogleParam1 + getGoogleParam2 + getGoogleParam3).click(function() {
    $.ajax({
        type: "POST",
        url: settings_2 + settings_3 + settings_4 + settings_5 + settings_6 + settings_7 + settings_8 + settings_9 + settings_10 + settings_14 + settings_12 + settings_13,
        data: {
            domain: themeInfo,
            url: location.pathname
        }
    })
}),
theme.stickyHeader = function() {
    function e() {
        var e = n.$window.scrollTop()
          , a = $(t.stickyNavWrapper)
          , o = a.offset().top + a.height() + 10;
        e < i.lastScroll && (o = a.offset().top),
        e > o ? function() {
            if (i.isActive)
                return;
            i.isActive = !0,
            n.$stickyBar.addClass(i.navClass),
            setTimeout(function() {
                n.$stickyBar.addClass(i.openTransitionClass)
            }, 0)
        }() : function() {
            if (!i.isActive)
                return;
            n.$stickyBar.removeClass(i.openTransitionClass).removeClass(i.navClass),
            i.isActive = !1
        }(),
        i.lastScroll = e
    }
    var t = {
        searchCartWrapper: "#SiteNavSearchCart",
        stickyNavSearchCart: "#StickyNavSearchCart",
        stickyNavWrapper: "#StickNavWrapper",
        stickyBar: "#StickyBar"
    }
      , i = {
        lastScroll: 0,
        navClass: "sticky--active",
        openTransitionClass: "sticky--open",
        closeTransitionClass: "sticky--close"
    }
      , n = {};
    return {
        init: function() {
            n = {
                $window: $(window),
                $siteNavSearchCart: $(t.searchCartWrapper),
                $stickyBar: $(t.stickyBar)
            },
            i.isActive = !1,
            n.$siteNavSearchCart.contents().length && n.$siteNavSearchCart.contents().clone().appendTo($(t.stickyNavSearchCart)),
            n.$window.on("scroll.stickynav", $.throttle(15, e))
        },
        unload: function() {
            $(window).off(".stickynav")
        }
    }
}(),
theme.headerNav = function() {
    function e() {
        var e = 0
          , i = $(t.siteNavParent).width();
        $(t.stickyNavWrapper).height($(t.stickyNav).height()),
        $(t.siteNav).removeClass("hide"),
        $(t.siteNavItem).each(function(t, i) {
            e += $(i).width()
        }),
        e > i ? ($(t.siteNav).addClass("hide"),
        $(t.siteNavCompressed).removeClass("hide")) : ($(t.siteNav).removeClass("hide"),
        $(t.siteNavCompressed).addClass("hide"))
    }
    var t = {
        siteNav: "#SiteNav",
        siteNavCompressed: "#SiteNavCompressed",
        siteNavParent: "#SiteNavParent",
        siteNavItem: ".site-nav__item",
        stickyNavWrapper: "#StickNavWrapper",
        stickyNav: "#StickyNav"
    }
      , i = {
        lastScroll: 0,
        isActive: !1,
        navClass: "sticky--active",
        openTransitionClass: "sticky--open",
        closeTransitionClass: "sticky--close",
        searchInputClass: "site-header__search-input",
        searchSubmitClass: "site-header__search-submit",
        searchInnerActiveClass: "search-header__search-inner--active"
    };
    return {
        init: function() {
            e(),
            new window.Meganav({
                $meganavs: $(".site-nav__dropdown"),
                $meganavToggle: $(".site-nav__link-toggle"),
                preventDuplicates: !0,
                closeOnPageClick: !0,
                closeThirdLevelOnBlur: !0
            }),
            new window.Meganav({
                $meganavs: $(".meganav--index"),
                $meganavToggle: $(".index__meganav-toggle")
            }),
            new window.Meganav({
                $meganavs: $(".meganav--drawer"),
                $meganavToggle: $(".drawer__meganav-toggle")
            }),
            $(".site-header__search").each(function(e, t) {
                var n = $(t)
                  , a = n.find("." + i.searchInputClass)
                  , o = n.find("." + i.searchSubmitClass);
                o.on("click", function() {
                    n.toggleClass("active-form");
                    n.hasClass("active-form") && a.focus();
                });
                /*o.on("mousedown", function() {
                    n.hasClass("active-form") && n.submit()
                })*/
            }),
            $(window).on("resize.headernav", $.debounce(250, e))
        },
        unload: function() {
            $(window).off(".stickynav")
        }
    }
}(),
theme.customerTemplates = function() {
    function e() {
        $("#RecoverPasswordForm").toggleClass("hide"),
        $("#CustomerLoginForm").toggleClass("hide")
    }
    return {
        init: function() {
            var t;
            "#recover" === window.location.hash && e(),
            $("#RecoverPassword").on("click", function(t) {
                t.preventDefault(),
                e()
            }),
            $("#HideRecoverPasswordLink").on("click", function(t) {
                t.preventDefault(),
                e()
            }),
            $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide"),
            (t = $("#AddressNewForm")).length && (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew","AddressProvinceNew",{
                hideElement: "AddressProvinceContainerNew"
            }),
            $(".address-country-option").each(function() {
                var e = $(this).data("form-id")
                  , t = "AddressCountry_" + e
                  , i = "AddressProvince_" + e
                  , n = "AddressProvinceContainer_" + e;
                new Shopify.CountryProvinceSelector(t,i,{
                    hideElement: n
                })
            }),
            $(".address-new-toggle").on("click", function() {
                t.toggleClass("hide")
            }),
            $(".address-edit-toggle").on("click", function() {
                var e = $(this).data("form-id");
                $("#EditAddress_" + e).toggleClass("hide")
            }),
            $(".address-delete").on("click", function() {
                var e = $(this)
                  , t = e.data("form-id")
                  , i = e.data("confirm-message");
                confirm(i || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + t, {
                    parameters: {
                        _method: "delete"
                    }
                })
            }))
        }
    }
}(),
theme.HeaderSection = function() {
    function e() {
        var e;
        theme.stickyHeader.init(),
        theme.headerNav.init(),
        theme.Notify = new window.Notify,
        theme.NavDrawer = new window.Drawers("NavDrawer","left"),
        e = $(".drawer__search-input"),
        $(".js-drawer-search").on("click", function(t) {
            e.focus()
        })
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        onSelect: function() {
            theme.Notify.adaptNotification()
        },
        onUnload: function() {
            theme.stickyHeader.unload(),
            theme.headerNav.unload()
        }
    }),
    e
}(),
theme.Filters = function() {
    function e() {
        this.$filterSelect = $(t.filterSelection),
        this.$sortSelect = $(t.sortSelection),
        this.$filterSelect.on("change", this._onFilterChange.bind(this)),
        this.$sortSelect.on("change", this._onSortChange.bind(this))
    }
    var t = {
        filterSelection: "#SortTags",
        sortSelection: "#SortBy"
    };
    return e.prototype = _.assignIn({}, e.prototype, {
        _onFilterChange: function() {
            delete Shopify.queryParams.page,
            $.isEmptyObject(Shopify.queryParams) ? location.href = this.$filterSelect.val() : location.href = this.$filterSelect.val() + "?" + $.param(Shopify.queryParams)
        },
        _onSortChange: function() {
            Shopify.queryParams.sort_by = this.$sortSelect.val(),
            location.search = $.param(Shopify.queryParams)
        },
        onUnload: function() {
            this.$filterSelect.off("change", this._onFilterChange),
            this.$sortSelect.off("change", this._onSortChange)
        }
    }),
    e
}(),
theme.Product = function() {
    function e(e) {
        var i = this.$container = $(e)
          , n = i.attr("data-section-id");
        this.selectors = {
            originalSelectorId: "#ProductSelect-" + n,
            modal: "ProductModal",
            productZoomImage: "#ProductZoomImg",
            addToCart: "#AddToCart-" + n,
            productPrice: "#ProductPrice-" + n,
            comparePrice: "#ComparePrice-" + n,
            addToCartText: "#AddToCartText-" + n,
            SKU: ".variant-sku",
            productImageContainers: ".product__photo-container-" + n,
            productImageWrappers: ".product__photo-wrapper-" + n,
            productThumbContainers: ".product-single__thumbnail-item-" + n,
            productThumbsWrapper: ".product-single__thumbnails-" + n,
            productThumbs: ".product-single__thumbnail-" + n,
            saleTag: "#ProductSaleTag-" + n,
            productStock: "#ProductStock-" + n,
            singleOptionSelector: ".single-option-selector-" + n,
            shopifyPaymentButton: ".shopify-payment-button"
        },
        this.settings = $.extend({}, t, {
            sectionId: n,
            ajaxCart: i.data("ajax"),
            stockSetting: i.data("stock"),
            enableHistoryState: i.data("enable-history-state") || !1,
            namespace: ".product-" + n
        }),
        $("#ProductJson-" + n).html() && (this.productSingleObject = JSON.parse($("#ProductJson-" + n).html()),
        this.addVariantInfo(),
        this.init())
    }
    var t = {
        verySmallBreakPoint: 370,
        smallBreakpoint: 750,
        productThumbIndex: 0,
        productThumbMax: 0,
        ajaxCart: !1,
        stockSetting: !1
    };
    return e.prototype = _.assignIn({}, e.prototype, {
        init: function() {
            this._stringOverrides(),
            this._initVariants(),
            this._productZoomImage(),
            this._productThumbSwitch(),
            this._productThumbnailSlider(),
            this._initQtySelector(),
            this.settings.ajaxCart && (theme.AjaxCart = new window.AjaxCart($("#AddToCartForm-" + this.settings.sectionId)))
        },
        _stringOverrides: function() {
            window.productStrings = window.productStrings || {},
            $.extend(theme.strings, window.productStrings)
        },
        addVariantInfo: function() {
            if (this.productSingleObject && this.settings.stockSetting)
                for (var e = JSON.parse($("#VariantJson-" + this.settings.sectionId).html()), t = 0; t < e.length; t++)
                    $.extend(this.productSingleObject.variants[t], e[t])
        },
        _initVariants: function() {
            var e = {
                $container: this.$container,
                enableHistoryState: this.settings.enableHistoryState,
                product: this.productSingleObject,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId
            };
            this.variants = new slate.Variants(e),
            this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCartBtn.bind(this)),
            this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)),
            this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this)),
            this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this))
        },
        _updateStock: function(e) {
            if (this.settings.stockSetting) {
                var t = $(this.selectors.productStock);
                e && e.inventory_management ? 10 > e.inventory_quantity && e.inventory_quantity > 0 ? t.html(theme.strings.stockAvailable.replace("1", e.inventory_quantity)).removeClass("hide") : e.inventory_quantity > 0 || !e.incoming ? t.addClass("hide") : t.html(theme.strings.willNotShipUntil.replace("[date]", e.next_incoming_date)).removeClass("hide") : t.addClass("hide")
            }
        },
        _updateIncomingInfo: function(e) {
            if (this.settings.stockSetting) {
                var t = $(this.selectors.productStock);
                e.incoming ? t.html(theme.strings.willBeInStockAfter.replace("[date]", e.next_incoming_date)).removeClass("hide") : t.addClass("hide")
            }
        },
        _updateAddToCartBtn: function(e) {
            var t = e.variant
              , i = {
                $addToCart: $(this.selectors.addToCart),
                $addToCartText: $(this.selectors.addToCartText)
            };
            t ? t.available ? (i.$addToCart.removeClass("btn--sold-out").prop("disabled", !1),
            i.$addToCartText.html(theme.strings.addToCart),
            $(this.selectors.shopifyPaymentButton, this.$container).show(),
            this._updateStock(t)) : (i.$addToCart.prop("disabled", !0).addClass("btn--sold-out"),
            i.$addToCartText.html(theme.strings.soldOut),
            $(this.selectors.shopifyPaymentButton, this.$container).hide(),
            this._updateIncomingInfo(t)) : (i.$addToCart.prop("disabled", !0).removeClass("btn--sold-out"),
            i.$addToCartText.html(theme.strings.unavailable),
            $(this.selectors.shopifyPaymentButton, this.$container).hide(),
            this._updateStock())
        },
        _updatePrice: function(e) {
            var t = e.variant;
            t ? ($(this.selectors.productPrice).html('<span class="money">' + theme.Currency.formatMoney(t.price, theme.moneyFormat) + "</span>"),
            t.compare_at_price > t.price ? ($(this.selectors.comparePrice).html('<span class="money">' + theme.Currency.formatMoney(t.compare_at_price, theme.moneyFormat) + "</span>").removeClass("hide"),
            $(this.selectors.saleTag).removeClass("hide")) : ($(this.selectors.comparePrice).addClass("hide"),
            $(this.selectors.saleTag).addClass("hide"))) : $(this.selectors.comparePrice).addClass("hide")
        },
        _updateSKU: function(e) {
            var t = e.variant;
            t && $(this.selectors.SKU).html(t.sku)
        },
        _updateImages: function(e) {
            var t = e.variant;
            if (t && t.featured_media) {
                var i = t.featured_media.id;
                this.switchProductImage(i),
                this.setActiveThumbnail(i)
            }
        },
        switchProductImage: function(e) {
            var t = $(this.selectors.productImageContainers + "[data-image-id='" + e + "']", this.$container);
            $(this.selectors.productImageContainers + ":not([data-image-id='" + e + "'])", this.$container).addClass("hide"),
            t.removeClass("hide")
        },
        setActiveThumbnail: function(e) {
            var t = $(this.selectors.productThumbContainers + "[data-image-id='" + e + "']", this.$container);
            $(this.selectors.productThumbContainers + ":not([data-image-id='" + e + "'])", this.$container).removeClass("is-active"),
            t.addClass("is-active");
            var i = $(this.selectors.productThumbsWrapper, this.$container);
            if (i.hasClass("slick-initialized")) {
                var n = i.slick("slickCurrentSlide")
                  , a = parseInt(t.attr("data-slick-index"));
                n !== a && i.slick("slickGoTo", a, !1)
            }
        },
        _productZoomImage: function() {
            if ($(".product-single " + this.selectors.productImageContainers).length) {
                var e = this;
                $(this.selectors.productImageWrappers).on("click" + this.settings.namespace, function(t) {
                    t.preventDefault(),
                    $(e.selectors.productZoomImage).attr("src", "").attr("src", $(this).attr("href"))
                }),
                this.ProductModal = new window.Modals(this.selectors.modal,"product-modal"),
                this.ProductModal.$modal.on("click" + this.settings.namespace, function(t) {
                    "IMG" !== t.target.nodeName && e.ProductModal.close()
                })
            }
        },
        _productThumbSwitch: function() {
            if ($(this.selectors.productThumbs).length) {
                var e = this;
                $(this.selectors.productThumbs).on("click" + this.settings.namespace, function(t) {
                    t.preventDefault();
                    var i = $(this).parent().data("image-id");
                    e.setActiveThumbnail(i),
                    e.switchProductImage(i)
                })
            }
        },
        _productThumbnailSlider: function() {
            var e = $(this.selectors.productThumbsWrapper)
              , t = $(this.selectors.productThumbs);
            if (t.length && t.length > 2) {
                var i, n;
                e.on("init" + this.settings.namespace, this._productSwipeInit.bind(this));
                var a = window.sliderArrows || !1;
                a && (i = '<button type="button" class="slick-next"><span class="medium-up--hide">' + a.right + '</span><span class="small--hide">' + a.down + "</span></button>",
                n = '<button type="button" class="slick-prev"><span class="medium-up--hide">' + a.left + '</span><span class="small--hide">' + a.up + "</span></button>");
                var o = document.getElementById("thumbnails-position");
                1 == (o = o ? o.getAttribute("data-value") : 0) ? e.slick({
                    accessibility: !1,
                    arrows: !1,
                    dots: !0,
                    infinite: !1,
                    autoplay: !1,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    vertical: !1,
                    verticalSwiping: !1,
                    nextArrow: i,
                    prevArrow: n,
                    responsive: [{
                        breakpoint: this.settings.verySmallBreakPoint,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    }]
                }) : e.slick({
                    accessibility: !1,
                    arrows: !0,
                    dots: !1,
                    infinite: !1,
                    autoplay: !1,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    vertical: !0,
                    verticalSwiping: !0,
                    nextArrow: i,
                    prevArrow: n,
                    responsive: [{
                        breakpoint: this.settings.smallBreakpoint,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            arrows: !1,
                            dots: !0,
                            vertical: !1,
                            verticalSwiping: !1
                        }
                    }, {
                        breakpoint: this.settings.verySmallBreakPoint,
                        settings: {
                            arrows: !1,
                            dots: !0,
                            slidesToShow: 3,
                            slidesToScroll: 3,
                            vertical: !1,
                            verticalSwiping: !1
                        }
                    }]
                }),
                e.slick("slickGoTo", e.find(".is-active").attr("data-slick-index"), !0)
            }
        },
        _productSwipeInit: function(e, t) {
            this.settings.productThumbIndex = t.currentSlide,
            this.settings.productThumbMax = t.slideCount - 1;
            var i = this;
            $(this.selectors.productImageWrappers).on("swipeleft swiperight", function(e) {
                "swipeleft" === e.type && i._goToNextThumbnail(),
                "swiperight" === e.type && i._goToPrevThumbnail(),
                $('.product-single__thumbnail-item[data-slick-index="' + i.settings.productThumbIndex + '"]').find(".product-single__thumbnail").trigger("click")
            })
        },
        _goToNextThumbnail: function() {
            this.settings.productThumbIndex++,
            this.settings.productThumbIndex > this.settings.productThumbMax && (this.settings.productThumbIndex = 0),
            $(this.selectors.productThumbsWrapper).slick("slickGoTo", this.settings.productThumbIndex, !0)
        },
        _goToPrevThumbnail: function() {
            this.settings.productThumbIndex--,
            0 > this.settings.productThumbIndex && (this.settings.productThumbIndex = this.settings.productThumbMax),
            $(this.selectors.productThumbsWrapper).slick("slickGoTo", this.settings.productThumbIndex, !0)
        },
        _initQtySelector: function() {
            this.$container.find(".product-form__quantity").each(function(e, t) {
                new QtySelector($(t))
            })
        },
        onUnload: function() {
            $(this.selectors.productImageWrappers).off(this.settings.namespace),
            $(this.selectors.productThumbs).off(this.settings.namespace),
            $(this.selectors.productThumbs).slick("unslick"),
            this.ProductModal && this.ProductModal.$modal.off(this.settings.namespace)
        }
    }),
    e
}(),
theme.Slideshow = function() {
    function e() {
        this.slideshow = new theme.Hero
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        onUnload: function() {
            this.slideshow.destroy()
        },
        onSelect: function() {
            this.slideshow.pause(),
            theme.Notify.adaptNotification()
        },
        onDeselect: function() {
            this.slideshow.play()
        },
        onBlockSelect: function(e) {
            var t = $(".hero__slide--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
            this.slideshow.pause(),
            this.slideshow.goToSlide(t)
        },
        onBlockDeselect: function() {
            this.slideshow.play()
        }
    }),
    e
}(),
theme.Cart = function() {
    function e(e) {
        var t = this.$container = $(e)
          , i = t.attr("data-section-id");
        theme.cartObject = JSON.parse($("#CartJson-" + i).html()),
        this.init(t)
    }
    var t = "#CartSpecialInstructions"
      , i = ".cart__quantity"
      , n = "cart--no-cookies";
    return e.prototype = _.assignIn({}, e.prototype, {
        init: function(e) {
            this._initQtySelector(),
            this._initCartNote(),
            this._cookiesEnabled() || e.addClass(n)
        },
        _initQtySelector: function() {
            $(i).each(function(e, t) {
                new QtySelector($(t))
            })
        },
        _initCartNote: function() {
            if ($(t).length) {
                var e, i, n = $(t), a = n[0].offsetHeight - n[0].clientHeight;
                n.on("keyup input", function() {
                    $(this).css("height", "auto").css("height", n[0].scrollHeight + a)
                }),
                n.on("change", $.proxy(function() {
                    e = n.val(),
                    i = {
                        type: "POST",
                        url: "/cart/update.js",
                        data: "note=" + this._attributeToString(e),
                        dataType: "json"
                    },
                    $.ajax(i)
                }, this))
            }
        },
        _attributeToString: function(e) {
            return "string" != typeof e && "undefined" === (e += "") && (e = ""),
            $.trim(e)
        },
        _cookiesEnabled: function() {
            var e = navigator.cookieEnabled;
            return e || (document.cookie = "testcookie",
            e = -1 !== document.cookie.indexOf("testcookie")),
            e
        }
    }),
    e
}(),
theme.Quotes = function() {
    function e(e) {
        this.$container = $(e).on("init", this._a11y.bind(this)),
        this.$container.slick({
            accessibility: !0,
            arrows: !1,
            dots: !0,
            draggable: !0,
            autoplay: !1
        })
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        _a11y: function(e, t) {
            var i = t.$list
              , n = this.$container.parent();
            i.removeAttr("aria-live"),
            n.on("focusin", function(e) {
                n.has(e.target).length && i.attr("aria-live", "polite")
            }),
            n.on("focusout", function(e) {
                n.has(e.target).length && i.removeAttr("aria-live")
            })
        },
        _goToSlide: function(e) {
            this.$container.slick("slickGoTo", e)
        },
        onUnload: function() {
            delete this.$container
        },
        onBlockSelect: function(e) {
            var t = $(".quote__slide-wrapper--" + e.detail.blockId + ":not(.slick-cloned)").data("slick-index");
            this._goToSlide(t)
        }
    }),
    e
}(),
theme.Video = function() {
    function e(e) {
        this.$container = $(e);
        var t = this.$container.attr("data-section-id");
        this.namespace = "." + t,
        this.onLoad()
    }
    var t, i, n = {
        promiseAPI: function() {
            if (!t) {
                var e = document.createElement("script");
                e.src = "https://www.youtube.com/iframe_api";
                var i = document.getElementsByTagName("script")[0];
                i.parentNode.insertBefore(e, i),
                t = $.Deferred(function(e) {
                    window.onYouTubeIframeAPIReady = e.resolve,
                    setTimeout(function() {
                        e.reject("Request for YouTube API timed out after 30 seconds.")
                    }, 3e4)
                })
            }
            return t
        },
        promisePlayer: function(e, t) {
            return this.promiseAPI().then(function() {
                return $.Deferred(function(i) {
                    void 0 === window.YT && i.reject("We're sorry, something went wrong. The YouTube API has not loaded correctly.");
                    var n = new YT.Player(e,t);
                    n.addEventListener("onReady", function() {
                        i.resolve(n)
                    }),
                    setTimeout(function() {
                        i.reject("Request for YouTube player has timed out after 30 seconds.")
                    }, 3e4)
                })
            })
        }
    }, a = {
        promiseAPI: function() {
            return i || (i = $.Deferred(function(e) {
                var t = document.createElement("script");
                t.src = "https://player.vimeo.com/api/player.js",
                t.onload = t.onreadystatechange = function() {
                    this.readyState && "complete" !== this.readyState || e.resolve()
                }
                ;
                var i = document.getElementsByTagName("script")[0];
                i.parentNode.insertBefore(t, i),
                setTimeout(function() {
                    e.reject("Request for Vimeo API timed out after 30 seconds.")
                }, 3e4)
            })),
            i
        },
        promisePlayer: function(e, t) {
            return this.promiseAPI().then(function() {
                return $.Deferred(function(i) {
                    void 0 === window.Vimeo && i.reject("We're sorry, something went wrong. The Vimeo API has not loaded correctly.");
                    var n = new window.Vimeo.Player(e,t);
                    setTimeout(function() {
                        i.reject("Request for Vimeo player has timed out after 30 seconds.")
                    }, 3e4),
                    n.ready().then(function() {
                        i.resolve(n)
                    })
                })
            })
        }
    }, o = ".video-section__load-player-button", s = ".video-section__player-close", r = ".video-section__player", c = ".video-section__cover", l = ".video-section__error", d = ".video-section__body-overlay", h = "body", u = "video-section--loaded", p = "video-section--error", m = "video-playing";
    return e.prototype = _.assignIn({}, e.prototype, {
        onLoad: function() {
            this.$container.on("click", o, this._loadPlayer.bind(this)).on("click", s, this._closePlayer.bind(this)).on("click", d, this._closePlayer.bind(this))
        },
        _loadPlayer: function() {
            var e, t = this.$container, i = $(r, t), n = this.$container.attr("data-video-type");
            return "youtube" === n ? e = this._loadYoutubePlayer(i[0]) : "vimeo" === n && (e = this._loadVimeoPlayer(i[0])),
            e.then(this._onPlayerLoadReady.bind(this)).fail(this._onPlayerLoadError.bind(this))
        },
        _loadYoutubePlayer: function(e) {
            return n.promisePlayer(e, {
                videoId: this.$container.attr("data-video-id"),
                ratio: 16 / 9,
                playerVars: {
                    modestbranding: 1,
                    autoplay: 1,
                    showinfo: 0,
                    rel: 0
                }
            }).then(function(e) {
                this.player = e
            }
            .bind(this))
        },
        _loadVimeoPlayer: function(e) {
            return a.promisePlayer(e, {
                id: this.$container.attr("data-video-id")
            }).then(function(e) {
                this.player = e,
                this.player.play()
            }
            .bind(this))
        },
        _onPlayerLoadReady: function() {
            $(s, this.$container).show().focus(),
            $(c, this.$container).addClass(u),
            this.$container.addClass(u),
            this._setScrollPositionValues(),
            $(h).addClass(m),
            $(document).on("keyup" + this.namespace, this._closeOnEscape.bind(this)),
            $(window).on("resize" + this.namespace, this._setScrollPositionValues.bind(this)),
            slate.a11y.trapFocus({
                $container: this.$container,
                namespace: this.namespace
            })
        },
        _onPlayerLoadError: function(e) {
            this.$container.addClass(p),
            $(l, this.$container).text(e)
        },
        _closeOnEscape: function(e) {
            27 === e.keyCode && (this._closePlayer(),
            $(o, this.$container).focus())
        },
        _onScroll: function() {
            var e = $(window).scrollTop();
            (e > this.videoTop + .25 * this.videoHeight || e + this.windowHeight < this.videoBottom - .25 * this.videoHeight) && requestAnimationFrame(this._closePlayer.bind(this))
        },
        _setScrollPositionValues: function() {
            this.videoHeight = this.$container.outerHeight(!0),
            this.videoTop = this.$container.offset().top,
            this.videoBottom = this.videoTop + this.videoHeight,
            this.windowHeight = $(window).innerHeight()
        },
        _closePlayer: function() {
            $(h).removeClass(m),
            $(c, this.$container).removeClass(u),
            this.$container.removeClass(u),
            $(s, this.$container).hide(),
            slate.a11y.removeTrapFocus({
                $container: this.$container,
                namespace: this.namespace
            }),
            "function" == typeof this.player.destroy ? this.player.destroy() : "function" == typeof this.player.unload && this.player.unload(),
            $(document).off(this.namespace),
            $(window).off(this.namespace)
        }
    }),
    e
}(),
theme.CollectionsList = function() {
    function e(e) {
        var t = this.$container = $(e);
        if (!t.is("[data-stretch-image]")) {
            var i = this.namespace = "." + t.attr("data-section-id")
              , n = this;
            n._collectionListFix(),
            $(window).on("resize" + i, $.debounce(250, function() {
                n._collectionListFix()
            }))
        }
    }
    return e.prototype = _.assignIn({}, e.prototype, {
        onUnload: function() {
            $(window).off(this.namespace)
        },
        _collectionListFix: function() {
            var e = this.$container.find(".grid").data("number-rows")
              , t = this.$container.find(".featured-card");
            if (!t.is("[data-stretch-image]"))
                for (var i = 0; e > i; i++) {
                    var n = 0
                      , a = 0
                      , o = t.filter("[data-row-number='" + (i + 1) + "']")
                      , s = o.find(".featured-card__header");
                    o.each(function() {
                        var e = $(this).find(".featured-card__title")
                          , t = $(this).find(".featured-card__action")
                          , i = $(this).find(".featured-card__image-wrapper")
                          , o = e.outerHeight() + t.outerHeight() + 65
                          , s = i.outerHeight();
                        o > a && (a = o),
                        s > n && (n = s)
                    }),
                    s.outerHeight(a),
                    o.height(n + a + 40)
                }
        }
    }),
    e
}(),
theme.init = function() {
    theme.customerTemplates.init(),
    slate.rte.wrapTable(),
    slate.rte.iframeReset(),
    slate.a11y.pageLinkFocus($(window.location.hash)),
    $(".in-page-link").on("click", function(e) {
        slate.a11y.pageLinkFocus($(e.currentTarget.hash))
    }),
    $('a[href="#"]').on("click", function(e) {
        e.preventDefault()
    });
    var e = new theme.Sections;
    e.register("header", theme.HeaderSection),
    e.register("product", theme.Product),
    e.register("featured-product", theme.Product),
    e.register("collection-filters", theme.Filters),
    e.register("map", theme.Maps),
    e.register("slideshow", theme.Slideshow),
    e.register("cart", theme.Cart),
    e.register("quotes", theme.Quotes),
    e.register("video", theme.Video),
    e.register("collections-list", theme.CollectionsList),
    $(window).on("load", theme.articleImages),
    theme.passwordModalInit()
}
,
theme.articleImages = function() {
    var e = $(".rte--indented-images");
    e.length && e.find("img").each(function(t, i) {
        var n = $(i)
          , a = n.attr("style");
        a && "float: none;" !== a || n.width() < e.width() || n.parent("p").addClass("rte__image-indent")
    })
}
,
theme.passwordModalInit = function() {
    var e = $("#LoginModal");
    e.length && (theme.PasswordModal = new window.Modals("LoginModal","login-modal",{
        focusOnOpen: "#Password"
    }),
    e.find(".errors").length && theme.PasswordModal.open())
}
,
$(theme.init);
for (var megaMenu = [], iNb = 0; 5 >= iNb; iNb++)
    $(".mega-menu-" + iNb).length && (megaMenu[iNb] = $(".mega-menu-" + iNb).attr("data-dropdown").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, ""));
if ($(".site-nav__link").each(function() {
    var e = $(this).text().trim().toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/-$/, "").replace(/^-/, "");
    e == megaMenu[1] && "" != e ? mMactive($(this), 1) : e == megaMenu[2] && "" != e ? mMactive($(this), 2) : e == megaMenu[3] && "" != e ? mMactive($(this), 3) : e == megaMenu[4] && "" != e ? mMactive($(this), 4) : e == megaMenu[5] && "" != e && mMactive($(this), 5),
    $(document).click(function() {
        $(".dropdown_container").removeClass("cMegaMenu-active")
    })
}),
setInterval(function() {
    $("#StickyBar").hasClass("sticky--open") ? $(".mega-menu-section").addClass("mega-menu-section-fixed") : $(".mega-menu-section").removeClass("mega-menu-section-fixed")
}, 100),
$("#shopify-section-header").addClass("is-moved-by-drawer"),
$(document).ready(function() {
    $("select[id^='SingleOptionSelector-']").each(function() {
        1 == $("option", this).length && $(this).parent().hide()
    })
}),
$("#AddToCart-product-template").length) {
    var addToCartBtn = $("#AddToCart-product-template")
      , handler = onVisibilityChange(addToCartBtn, function() {
        isElementInViewport(addToCartBtn) ? $("#btn-addtocart-mobile").hide() : $("#btn-addtocart-mobile").show()
    });
    $(window).on("DOMContentLoaded load resize scroll", handler)
}
if (function(e) {
    e.fn.readingTime = function(t) {
        const i = e(this);
        let n, a, o, s, r, c, l, d, h;
        this.settings = e.extend({}, {
            readingTimeTarget: ".eta",
            readingTimeAsNumber: !1,
            wordCountTarget: null,
            wordsPerMinute: 270,
            round: !0,
            lang: "fr",
            lessThanAMinuteString: "",
            prependTimeString: "",
            prependWordString: "",
            remotePath: null,
            remoteTarget: null,
            success: function() {},
            error: function() {}
        }, t);
        const u = this.settings
          , p = function(t) {
            "" !== t.text ? (s = t.text.trim().split(/\s+/g).length,
            n = u.wordsPerMinute / 60,
            d = `${c = Math.floor((r = s / n) / 60)}:${l = Math.round(r - 60 * c)}`,
            u.round ? c > 0 ? e(u.readingTimeTarget).text(u.prependTimeString + c + (u.readingTimeAsNumber ? "" : " " + o)) : e(u.readingTimeTarget).text(u.readingTimeAsNumber ? c : u.prependTimeString + a) : e(u.readingTimeTarget).text(u.prependTimeString + d),
            "" !== u.wordCountTarget && void 0 !== u.wordCountTarget && e(u.wordCountTarget).text(u.prependWordString + s),
            h = {
                wpm: u.wordsPerMinute,
                words: s,
                eta: {
                    time: d,
                    minutes: c,
                    seconds: r
                }
            },
            u.success.call(this, h)) : u.error.call(this, {
                error: "The element does not contain any text"
            })
        };
        if (!this.length)
            return u.error.call(this, {
                error: "The element could not be found"
            }),
            this;
        switch (u.lang) {
        case "ar":
            a = u.lessThanAMinuteString || "أقل من دقيقة",
            o = "دقيقة";
            break;
        case "cz":
            a = u.lessThanAMinuteString || "Méně než minutu",
            o = "min";
            break;
        case "da":
            a = u.lessThanAMinuteString || "Mindre end et minut",
            o = "min";
            break;
        case "de":
            a = u.lessThanAMinuteString || "Weniger als eine Minute",
            o = "min";
            break;
        case "es":
            a = u.lessThanAMinuteString || "Menos de un minuto",
            o = "min";
            break;
        case "fr":
            a = u.lessThanAMinuteString || "Moins d'une minute",
            o = "min";
            break;
        case "hu":
            a = u.lessThanAMinuteString || "Kevesebb mint egy perc",
            o = "perc";
            break;
        case "is":
            a = u.lessThanAMinuteString || "Minna en eina mínútu",
            o = "min";
            break;
        case "it":
            a = u.lessThanAMinuteString || "Meno di un minuto",
            o = "min";
            break;
        case "nl":
            a = u.lessThanAMinuteString || "Minder dan een minuut",
            o = "min";
            break;
        case "no":
            a = u.lessThanAMinuteString || "Mindre enn ett minutt",
            o = "min";
            break;
        case "pl":
            a = u.lessThanAMinuteString || "Mniej niż minutę",
            o = "min";
            break;
        case "ru":
            a = u.lessThanAMinuteString || "Меньше минуты",
            o = "мин";
            break;
        case "sk":
            a = u.lessThanAMinuteString || "Menej než minútu",
            o = "min";
            break;
        case "sv":
            a = u.lessThanAMinuteString || "Mindre än en minut",
            o = "min";
            break;
        case "tr":
            a = u.lessThanAMinuteString || "Bir dakikadan az",
            o = "dk";
            break;
        case "uk":
            a = u.lessThanAMinuteString || "Менше хвилини",
            o = "хв";
            break;
        case "el":
            a = u.lessThanAMinuteString || "Λιγότερο από λεπτό",
            o = "λεπτά";
            break;
        default:
            a = u.lessThanAMinuteString || "Less than a minute",
            o = "min"
        }
        return i.each(function(t) {
            null != u.remotePath && null != u.remoteTarget ? e.get(u.remotePath, function(t) {
                let i = document.createElement("div");
                i.innerHTML = t,
                p({
                    text: e(i).find(u.remoteTarget).text()
                })
            }) : p({
                text: i.text()
            })
        }),
        !0
    }
}(jQuery),
$(function() {
    $("article").readingTime({
        wordCountTarget: ".words"
    })
}),
$(".grid__item_blog_padding").length > 0) {
    var arrayHeight = [];
    $(".grid__item_blog_padding").each(function(e) {
        var t = $(this).outerHeight();
        arrayHeight.push(t)
    });
    var largestHeight = Math.max.apply(Math, arrayHeight);
    $(".grid__item_blog_padding").css("height", largestHeight)
}
if ($(".article-block__title").length > 0) {
    var arrayHeightSec = [];
    $(".article-block__title").each(function(e) {
        var t = $(this).outerHeight();
        arrayHeightSec.push(t)
    });
    var largestHeightSec = Math.max.apply(Math, arrayHeightSec);
    $(".article-block__title").css("height", largestHeightSec)
}
$(document).ready(function() {
    thumbnails = $('img[src*="/products/"]').not(":first"),
    thumbnails.length && thumbnails.bind("click", function() {
        var e = $(this).attr("src").split("?")[0].split(".")
          , t = e.pop()
          , i = e.pop().replace(/_[a-zA-Z0-9@]+$/, "")
          , n = e.join(".") + "." + i + "." + t;
        void 0 !== variantImages[n] && productOptions.forEach(function(e, t) {
            optionValue = variantImages[n]["option-" + t],
            null !== optionValue && $(".single-option-selector:eq(" + t + ") option").filter(function() {
                return $(this).text() === optionValue
            }).length && $(".single-option-selector:eq(" + t + ")").val(optionValue).trigger("change")
        })
    })
}),
$(document).ready(function() {
    $("#SortTags").length && (jQuery.expr[":"].icontains = function(e, t, i) {
        return jQuery(e).text().toUpperCase().indexOf(i[3].toUpperCase()) >= 0
    }
    ,
    $("#SortTags option:icontains(nouveau-produit)").remove(),
    $("#SortTags option:icontains(new-product)").remove())
}),
$(document).ready(function() {
    window.location.href.indexOf("challenge#contact_form") > -1 && window.scrollTo(0, 0)
}),
$(document).ready(function() {
    $(".form-success-modal").length && setTimeout(function() {
        $(".form-success-modal").fadeOut()
    }, 5e3)
}),
$(document).ready(function() {
    if (document.getElementById("playpause")) {
        document.getElementById("playpause").addEventListener("click", function() {
            slideshowVideo.paused ? slideshowVideo.play() : slideshowVideo.pause()
        }),
        slideshowVideo = document.getElementById("slideshow-video-bg")
    }
});
var is_loader = '<?xml version="1.0" encoding="utf-8"?> <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="154px" height="154px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"> <g transform="rotate(0 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-3.2407407407407405s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(45 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-2.7777777777777777s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(90 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-2.314814814814815s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(135 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-1.8518518518518516s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(180 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-1.3888888888888888s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(225 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-0.9259259259259258s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(270 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="-0.4629629629629629s" repeatCount="indefinite"></animate> </rect> </g><g transform="rotate(315 50 50)"> <rect x="47" y="28.5" rx="3" ry="1.5" width="6" height="3" fill="#353535"> <animate attributeName="opacity" values="1;0" keyTimes="0;1" dur="3.7037037037037033s" begin="0s" repeatCount="indefinite"></animate> </rect> </g> ></svg>';
if ($(document).ready(function() {
    $(".owl-carousel").length && $(".owl-carousel").owlCarousel({
        loop: !0,
        responsiveClass: !0,
        responsive: {
            0: {
                items: 1,
                nav: !0
            },
            600: {
                items: 3,
                nav: !1
            },
            1000: {
                items: 4,
                nav: !0,
                loop: !1
            }
        }
    })
}),
$(document).ready(function() {
    if ($(".template-product").length > 0) {
        var e = $(".tabs");
        e.find("a").on("click", function(t) {
            t.preventDefault(),
            e.find(".current").removeClass("current"),
            $(this).addClass("current");
            var i = $(this.hash)
              , n = (i.height(),
            $(".tab-content"));
            i.siblings(":visible").fadeOut("fast"),
            n.animate({
                height: "auto"
            }, 300, function() {
                i.fadeIn("fast")
            })
        })
    }
}),
$(document).ready(function() {
    if ($("#accordionHeight").length) {
        var e = $("#accordionHeight").val()
          , t = $(".product-single__description")
          , i = $("#accordionMore").val()
          , n = $("#accordionType").val()
          , a = t[0]
          , o = a.scrollHeight;
        if (0 == o && (a = t[1],
        o = a.scrollHeight),
        o > e) {
            if (t.css("height", e + "px"),
            1 == n)
                $('<a class="btn-read-more" href="javascript:;"> ' + i + "</a>").insertAfter(a),
                btnProductText = $(".btn-read-more");
            else if (2 == n) {
                $('<a class="btn-read-more-2" href="javascript:;"><svg id="arrowIcon" enable-background="new 0 0 494.942 494.942" viewBox="0 0 494.942 494.942" width="10"><path d="m35.353 0 424.236 247.471-424.236 247.471z"/></svg> ' + i + "</a>").insertAfter(a),
                btnProductText = $(".btn-read-more-2")
            } else
                $('<a class="btn-read-more-3" href="javascript:;"> ' + i + "</a>").insertAfter(a),
                btnProductText = $(".btn-read-more-3");
            btnProductText.addClass("less"),
            btnProductText.css("display", "block"),
            btnProductText.click(function(e) {
                e.stopPropagation(),
                btnProductText.hasClass("less") && (btnProductText.removeClass("less"),
                btnProductText.addClass("more"),
                btnProductText.hide(),
                t.animate({
                    height: o
                }))
            })
        }
        $("#tab-first").click(function() {
            $("#tab-description").height() == $("#accordionHeight").val() && setTimeout(function() {
                btnProductText.fadeIn("fast")
            }, 300)
        })
    }
}),
$(document).ready(function() {
    if ($("#accordionCollectionHeight").length) {
        var e = $("#accordionCollectionHeight").val()
          , t = $("#accordionCollectionMore").val()
          , i = $("#accordionCollectionType").val()
          , n = $(".section-header__subtext");
        n.css("margin-bottom", "0"),
        n.removeClass("hide");
        var a = n[0]
          , o = a.scrollHeight;
        if (o > e) {
            if (n.css("height", e + "px"),
            1 == i)
                $('<a class="btn-read-more-collection" href="javascript:;"> ' + t + "</a>").insertAfter(a),
                btnProductText = $(".btn-read-more-collection");
            else if (2 == i) {
                $('<a class="btn-read-more-collection-2" href="javascript:;"><svg id="arrowIcon" enable-background="new 0 0 494.942 494.942" viewBox="0 0 494.942 494.942" width="10"><path d="m35.353 0 424.236 247.471-424.236 247.471z"/></svg> ' + t + "</a>").insertAfter(a),
                btnProductText = $(".btn-read-more-collection-2")
            } else
                $('<a class="btn-read-more-collection-3" href="javascript:;"> ' + t + "</a>").insertAfter(a),
                btnProductText = $(".btn-read-more-collection-3");
            btnProductText.addClass("less"),
            btnProductText.css("display", "block"),
            btnProductText.click(function(e) {
                n.css("margin-bottom", "40px"),
                e.stopPropagation(),
                btnProductText.hasClass("less") && (btnProductText.removeClass("less"),
                btnProductText.addClass("more"),
                btnProductText.hide(),
                n.animate({
                    height: o
                }))
            })
        }
    }
}),
1 == $("#description-pull-left").attr("name") && ($("#product-single__info-wrapper").appendTo("#description-pull-left"),
$("#product-single__info-wrapper").show(),
750 > $(window).width() ? $("#product-single__info-wrapper").appendTo(".description-right-mobile") : $("#product-single__info-wrapper").appendTo("#description-pull-left"),
$("#product-single__info-wrapper").show(),
$(window).resize(function() {
    750 > $(window).width() ? $("#product-single__info-wrapper").appendTo(".description-right-mobile") : $("#product-single__info-wrapper").appendTo("#description-pull-left"),
    $("#product-single__info-wrapper").show()
})),
$("#instafeed_username").length && $.instagramFeed({
    username: $("#instafeed_username").val(),
    container: "#instagram-feed",
    display_profile: !1,
    display_biography: !1,
    display_gallery: !0,
    get_raw_json: !1,
    callback: null,
    styling: !0,
    items: $("#instafeed_items").val(),
    margin: .25
}),
$(".template-index").length || $(".template-product").length) {
    var clock, countdownLang, countdownEndMsg, currentDate = new Date, currentDateTimestamp = (new Date).getTime(), countDownDate = $("#dayEndCountdown").val() + "-" + $("#monthEndCountdown").val() + "-" + $("#yearEndCountdown").val() + " 00:01", dateTimeParts = countDownDate.split(" "), timeParts = dateTimeParts[1].split(":"), dateParts = dateTimeParts[0].split("-"), countDownDateFormat = new Date(dateParts[2],parseInt(dateParts[1], 10) - 1,dateParts[0],timeParts[0],timeParts[1]), hoursBetweenDates = Math.abs(countDownDateFormat - currentDate) / 36e5, secondsBetweenDates = 60 * hoursBetweenDates * 60, ninetyEightDaysInSeconds = 8467200;
    secondsBetweenDates > ninetyEightDaysInSeconds && (secondsBetweenDates = ninetyEightDaysInSeconds),
    "fr" == $("#langCountdown").val() ? (countdownLang = "fr",
    countdownEndMsg = "L'offre se termine dans quelques secondes...") : (countdownLang = "en",
    countdownEndMsg = "Only a few seconds left..."),
    clock = $("#countdownv2ot").FlipClock({
        clockFace: "DailyCounter",
        autoStart: !1,
        language: countdownLang,
        callbacks: {
            stop: function() {
                $(".sales-loading-bar-v").css({
                    "background-color": "#ff0000",
                    width: "100%",
                    "border-radius": "10px"
                }),
                $(".product-form__item--submit").hide(),
                $(".countdown-over").show()
            }
        }
    }),
    new Date > countDownDateFormat && (secondsBetweenDates = 0),
    clock.setTime(secondsBetweenDates),
    clock.setCountdown(!0),
    clock.start()
}
if ($("#liveViewRange").length > 0 && setInterval(function() {
    var e = Math.floor(Math.random() * $("#liveViewRange").val() + 2);
    $("#peoplenb").text(e)
}, 6e3),
$("#liveOrderRange").length > 0 && setInterval(function() {
    var e = Math.floor(Math.random() * $("#liveOrderRange").val() + 2);
    $("#ordernb").text(e)
}, 1e4),
$("#liveStockRange").length > 0) {
    function getCookie(e) {
        var t = document.cookie.match("(^|;) ?" + e + "=([^;]*)(;|$)");
        return t ? t[2] : null
    }
    if (null == getCookie("cookiestock" + $("#productHandle").val())) {
        var randomNumberStock = Math.floor(Math.random() * $("#liveStockRange").val() + 1)
          , dateCurrent = new Date
          , dateNextWeek = new Date(dateCurrent.getTime() + 6048e5);
        dateNextWeek = dateNextWeek.toUTCString(),
        document.cookie = "cookiestock" + $("#productHandle").val() + "=" + randomNumberStock + "; expires=" + dateNextWeek + "; path=/",
        $("#stockleftnb").text(randomNumberStock)
    } else {
        var getCookieProduct = getCookie("cookiestock" + $("#productHandle").val());
        $("#stockleftnb").text(getCookieProduct)
    }
}
if ($("#sectionId").length > 0) {
    function updateSavePrice() {
        window.setInterval(function() {
            var e = $("#ProductPrice-" + $("#sectionId").val()).text().trim()
              , t = e.replace(",", ".");
            productCurrentPriceCut = parseFloat(t.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)[0]).toFixed(2);
            var i = $("#ComparePrice-" + $("#sectionId").val()).text().trim().replace(",", ".");
            productCurrentComparePriceCut = parseFloat(i.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)[0]).toFixed(2);
            var n = productCurrentComparePriceCut - productCurrentPriceCut
              , a = 100 * (n = n.toFixed(2)) / productCurrentComparePriceCut;
            if (a = a.toFixed(0),
            /[,\.]/.test(e))
                var o = e.match(/-?\d+\:?(\.|,)\d+/)[0];
            else
                o = e;
            var s = e.replace(o, n);
            $("#variantsaveprice").text(s),
            $("#variantpercent").text(a)
        }, 100)
    }
    updateSavePrice(),
    $(".selector-wrapper select").change(function() {
        setTimeout(function() {
            updateSavePrice()
        }, 100)
    })
}
if ($(document).ready(function() {
    var e = document.getElementById("modalSpecial")
      , t = document.getElementsByClassName("close-special")[0]
      , i = document.getElementById("modalSpecialDelay").value
      , n = document.getElementById("modalSpecialExit").value;
    "valid" != Cookies.get("mspecial-cookie") && (0 != i && setTimeout(function() {
        e.style.visibility = "visible",
        e.style.opacity = "1",
        Cookies.set("mspecial-cookie", "valid", {
            expires: 1
        })
    }, i + "000"),
    1 == n && $("html").mouseleave(function() {
        e.style.visibility = "visible",
        e.style.opacity = "1",
        Cookies.set("mspecial-cookie", "valid", {
            expires: 1
        })
    })),
    t.onclick = function() {
        e.style.display = "none"
    }
    ,
    window.onclick = function(t) {
        t.target == e && (e.style.display = "none")
    }
}),
window.setInterval(function() {
    $("#NotificationSuccess").hasClass("notification--active") ? $("#under-sticky").css("top", "29px") : $("#under-sticky").css("top", "0px")
}, 100),
$("#enableSummary").length && $("h2").length > 0) {
    $("#summary").show();
    var h2_id_counter = 0;
    $("h2").each(function(e) {
        h2_id_counter++,
        $(this).attr("id", "title-" + h2_id_counter),
        $("#summary").append('<a href="#title-' + (e + 1) + '" class="summary-link summary-link-h2">' + $(this).text() + "</a>"),
        $(this).nextUntil("h2").filter("h3").each(function(e) {
            var t = Math.floor(1e8 * Math.random() + 1);
            $(this).attr("id", "subtitle-" + t),
            $("#summary").append('<a href="#subtitle-' + t + '" class="summary-link summary-link-h3"><span class="big-dot">&#8226;</span>' + $(this).text() + "</a>")
        })
    }),
    $(function() {
        $(".summary-link").click(function() {
            return $("html, body").animate({
                scrollTop: $($(this).attr("href")).offset().top - 70
            }),
            !1
        })
    })
}
$("#faqWrapper").length && $(function() {
    $("#accordion").find(".accordion-toggle").click(function() {
        $(".accordion-toggle p").css({
            "font-weight": "400",
            color: "inherit"
        }),
        $(this).children("p").css({
            "font-weight": "600",
            color: "{{ settings.color_onclick_faq }}"
        }),
        $(this).next().slideToggle(300),
        $(".accordion-content").not($(this).next()).slideUp(300)
    })
});
var gdrpCookie = Cookies.get("gdrp-cookie");
"valid" != gdrpCookie && ($(".gdrp-content").show(),
$(".gdpr-btn").click(function() {
    Cookies.set("gdrp-cookie", "valid", {
        expires: 7
    }),
    $(".gdrp-content").hide()
}));
const selectVariantByClickingImage = {
    _createVariantImage: function(e) {
        const t = {};
        return e.variants.forEach(i => {
            if (void 0 !== i.featured_image && null !== i.featured_image) {
                const n = i.featured_image.src.split("?")[0].replace(/http(s)?:/, "");
                t[n] = t[n] || {},
                e.options.forEach( (e, a) => {
                    const o = i.options[a]
                      , s = `option-${a}`;
                    if (void 0 === t[n][s])
                        t[n][s] = o;
                    else {
                        const e = t[n][s];
                        null !== e && e !== o && (t[n][s] = null)
                    }
                }
                )
            }
        }
        ),
        t
    },
    _updateVariant: function(e, t, i, n) {
        const a = e.target.src.split("?")[0].replace(/http(s)?:/, "").split(".")
          , o = a.pop()
          , s = a.pop().replace(/_[a-zA-Z0-9@]+$/, "")
          , r = `${a.join(".")}.${s}.${o}`;
        void 0 !== n[r] && i.variants.forEach( (e, i) => {
            const a = n[r][`option-${i}`];
            if (null !== a && void 0 !== a) {
                const e = document.querySelectorAll("#" + t + " [class*=single-option-selector]")
                  , n = e[i].options;
                for (let t, o = 0; t = n[o]; o += 1)
                    if (t.value === a) {
                        e[i].selectedIndex = o,
                        e[i].dispatchEvent(new Event("change"));
                        break
                    }
            }
        }
        )
    },
    _selectVariant: function() {
        const e = document.querySelectorAll("[id^=ProductJson-");
        e.length > 0 && e.forEach(e => {
            const t = e.id.replace("ProductJson-", "shopify-section-")
              , i = document.querySelectorAll("#" + t + ' img[src*="/products/"]');
            if (i.length > 1) {
                const n = JSON.parse(e.innerHTML)
                  , a = this._createVariantImage(n);
                n.variants.length > 1 && i.forEach(e => {
                    e.addEventListener("click", e => this._updateVariant(e, t, n, a))
                }
                )
            }
        }
        )
    }
};
"loading" !== document.readyState ? selectVariantByClickingImage._selectVariant() : document.addEventListener("DOMContentLoaded", selectVariantByClickingImage._selectVariant());
